import React, { useEffect } from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BackButton } from '../components/common/BackButton';
import { useMetaPixel } from '../hooks/useMetaPixel';

export function ThankYouPage() {
  useMetaPixel('Lead');

  useEffect(() => {
    console.log('🎉 Thank You Page mounted - Meta Pixel Lead event should fire now');
    console.log('📊 Meta Pixel (fbq) available:', typeof window.fbq !== 'undefined');
  }, []);

  return (
    <div className="min-h-screen pt-32 px-4">
      <div className="max-w-4xl mx-auto">
        <BackButton to="/" label="Back to Home" />

        <div className="bg-black/50 border border-green-500/20 rounded-lg p-8 text-center">
          <div className="flex justify-center mb-6">
            <CheckCircle className="w-16 h-16 text-green-500" />
          </div>

          <h1 className="text-4xl font-bold text-white mb-4">
            Thank You!
          </h1>

          <p className="text-xl text-gray-300 mb-8">
            I've received your submission and will get back to you within 1 business day.
          </p>

          <div className="max-w-2xl mx-auto bg-black/30 border border-green-500/10 rounded-lg p-6">
            <h2 className="text-2xl font-bold text-white mb-4">
              While You Wait...
            </h2>

            <p className="text-gray-300 mb-6">
              Watch the video on our landing page to learn how we help health clinics get more clients
              without chasing leads or managing social media.
            </p>

            <Link
              to="/#video"
              className="inline-flex items-center gap-2 px-8 py-4 bg-green-500 text-black font-bold
                rounded-lg hover:bg-green-400 transition-all"
            >
              Watch the Video
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
